module.exports = __webpack_public_path__ + "static/media/Cheque_Template_1.5efc8915.png";